/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog500 } from "../models/UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog";

function getUsersAuthzAPIPermissionsCatalogGetPermissionsCatalogUrl() {
  const res = { method: 'GET', url: `/permissions-catalog` as const }  
  return res
}

/**
 * @description Returns a comprehensive list of all permissions from all APIs grouped by source
 * @summary Get all available permissions across all APIs
 * {@link /permissions-catalog}
 */
export async function usersAuthzAPIPermissionsCatalogGetPermissionsCatalog(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIPermissionsCatalogGetPermissionsCatalogQueryResponse, ResponseErrorConfig<UsersAuthzAPIPermissionsCatalogGetPermissionsCatalog500>, unknown>({ method : "GET", url : getUsersAuthzAPIPermissionsCatalogGetPermissionsCatalogUrl().url.toString(), ... requestConfig })  
  return res.data
}